import React, { useState } from "react";
import styles from "../styles/AncillaryFSICalculator.module.css";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const cityPercentageMap = {
  "Pune": 0.15,
  "Thane": 0.15,
  "Nagpur": 0.10,
  "Nashik Municipal Corporation": 0.10,
  "Other M.M.R. Municipal Corporations": 0.10,
  "CIDCO": 0.10,
  "All other Municipal Corporations": 0.10,
  "Municipal Councils": 0.10,
  "Nagar Panchayats": 0.10,
  "R.P. area": 0.10,
};

const AncillaryFSICalculator = () => {
  const [converterType, setConverterType] = useState("Premium for Ancillary FSI");
  const [cityType, setCityType] = useState("Nashik Municipal Corporation");
  const [fsiArea, setFsiArea] = useState(""); 
  const [rrRate, setRrRate] = useState(""); 
  const [premium, setPremium] = useState(""); 

  const navigate = useNavigate();

  const handleBack = () => navigate(-1);

  const handleDropdownChange = (e) => {
    const selected = e.target.value;
    setConverterType(selected);

    const pathMap = {
      "Area Convertor": "/area-convertor",
      "Built-up Area Calculator": "/built-up-area-calculator",
      "Development Charges": "/development-charges",
      "Premium for Ancillary FSI": "/ancillary-fsi",
      "⁠Premium for Premium FSI": "/premium-fsi",
      "ULC Premium": "/ulc-premium",
    };
    if (pathMap[selected]) navigate(pathMap[selected]);
  };

  const handleSubmit = () => {
    const area = parseFloat(fsiArea);
    const rate = parseFloat(rrRate);
    const percentage = cityPercentageMap[cityType] || 0;

    if (!isNaN(area) && !isNaN(rate)) {
      setPremium((area * rate * percentage).toFixed(2));
    } else {
      setPremium("Invalid input");
    }
  };

  return (
    <div className={styles.AncillaryFSICalculator_container}>
      <div className={styles.AncillaryFSICalculator_header}>
        <button
          className={styles.AncillaryFSICalculator_backButton}
          onClick={handleBack}
        >
          <FaArrowLeft />
        </button>
        <h2 className={styles.AncillaryFSICalculator_title}>Conversion Calculator</h2>
      </div>

      <div className={styles.AncillaryFSICalculator_dropdownContainer}>
        <select
          value={converterType}
          onChange={handleDropdownChange}
          className={styles.AncillaryFSICalculator_mainDropdown}
        >
          <option>Area Convertor</option>
          <option>Built-up Area Calculator</option>
          <option>Development Charges</option>
          <option>Premium for Ancillary FSI</option>
          <option>⁠Premium for Premium FSI</option>
          <option>ULC Premium</option>
        </select>
      </div>

      <div className={styles.AncillaryFSICalculator_card}>
        <h3 className={styles.AncillaryFSICalculator_sectionTitle}>Premium Amount</h3>

        <div className={styles.AncillaryFSICalculator_formGroup}>
          <label className={styles.AncillaryFSICalculator_label}>City/Town Type</label>
          <select
            className={styles.AncillaryFSICalculator_select}
            value={cityType}
            onChange={(e) => setCityType(e.target.value)}
          >
            {Object.keys(cityPercentageMap).map((city) => (
              <option key={city} value={city}>{city}</option>
            ))}
          </select>
        </div>

        <div className={styles.AncillaryFSICalculator_formGroup}>
          <label className={styles.AncillaryFSICalculator_label}>Ancillary FSI Area (sq.m):</label>
          <input
            type="number"
            className={styles.AncillaryFSICalculator_input}
            value={fsiArea}
            onChange={(e) => setFsiArea(e.target.value)}
          />
        </div>

        <div className={styles.AncillaryFSICalculator_formGroup}>
          <label className={styles.AncillaryFSICalculator_label}>Ready Reckoner Rate (₹/sq.m):</label>
          <input
            type="number"
            className={styles.AncillaryFSICalculator_input}
            value={rrRate}
            onChange={(e) => setRrRate(e.target.value)}
          />
        </div>

        <button
          className={styles.AncillaryFSICalculator_submitButton}
          onClick={handleSubmit}
        >
          Submit
        </button>

        <h3 className={styles.AncillaryFSICalculator_resultTitle}>Premium</h3>
        <p className={styles.AncillaryFSICalculator_resultValue}>
          {premium ? `₹ ${premium}` : "₹ 0.00"}
        </p>
      </div>
    </div>
  );
};

export default AncillaryFSICalculator;
